<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col sm="12" lg="4" md="12">
        <v-card class="elevation-15 pt-4 light_opacity">
          <v-window v-model="step">
            <v-window-item :value="0">
              <v-row>
                <v-col cols="12">
                  <v-card-text class="my-5">
                    <v-form ref="signinFrm" @submit.prevent="loginUser" lazy-validation>
                      <v-text-field
                        color="white"
                        v-model="signin.email"
                        label="Email Address"
                        name="email"
                        type="email"
                        :rules="emailRules"
                        required
                        outlined
                        solo
                      />
                      <v-text-field
                        color="white"
                        v-model="signin.password"
                        label="Password"
                        name="password"
                        type="password"
                        :rules="[!!signin.password || 'Password is Required']"
                        required
                        outlined
                        solo
                      />
                      <h3 class="text-center mt-4">
                        <a @click="step = 2">Forget your password?</a>
                      </h3>
                      <div class="text-center mt-4">
                        <v-btn color="primary" large class="mx-2" type="submit" :disabled="!valid">SIGN IN</v-btn>
                        <v-btn color="secondary" large outlined class="mx-2" @click="step++">Register</v-btn>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-window-item>
            <v-window-item :value="1">
              <v-row>
                <v-col cols="12">
                  <v-card-text class="my-5">
                    <v-form ref="registerFrm" @submit.prevent="registerUser" lazy-validation>
                      <v-row>
                        <v-col>
                          <v-text-field
                            v-model="register.firstName"
                            label="First Name"
                            name="name"
                            :rules="firstNameRules"
                            required
                            outlined
                            solo
                          ></v-text-field>
                          <v-text-field
                            v-model="register.lastName"
                            label="Last Name"
                            name="last_name"
                            :rules="lastNameRules"
                            required
                            outlined
                            solo
                          ></v-text-field>
                          <v-text-field
                            v-model="register.email"
                            label="Email"
                            name="email"
                            type="email"
                            :rules="emailRules"
                            required
                            outlined
                            solo
                          />
                          <base-user-role-picker
                            label="Role Type"
                            :initial="register.role"
                            :chosen-user-role.sync="register.role"
                            required
                            outlined
                            solo
                          />
                          <v-text-field
                            v-model="register.telNumber"
                            label="Mobile"
                            name="tel_number"
                            :rules="telNumberRules"
                            required
                            outlined
                            solo
                          />
                          <v-text-field
                            v-model="register.password"
                            label="Password"
                            name="password"
                            type="password"
                            :rules="passwordRules"
                            required
                            outlined
                            solo
                          />
                          <v-text-field
                            v-model="register.confirm"
                            label="Confirm"
                            name="confirm"
                            type="password"
                            :rules="[
                              !!register.confirm || 'Password Confirmation required',
                              (register.confirm && register.confirm == register.password) || 'Passwords do not match',
                            ]"
                            required
                            outlined
                            solo
                          />
                        </v-col>
                      </v-row>
                      <div class="text-center mt-4">
                        <v-btn color="primary" large class="mx-2" type="submit" :disabled="!valid"
                          >CREATE ACCOUNT</v-btn
                        >
                        <v-btn color="secondary" large outlined class="mx-2" @click="step--">SIGN IN</v-btn>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-window-item>
            <v-window-item :value="2">
              <v-row>
                <v-col cols="12">
                  <v-card-text class="py-5">
                    <h4 class="text-center text-md-h4 primary--text mb-5">
                      Forgot Password
                    </h4>
                    <v-form @submit.prevent="forgotPassword">
                      <v-text-field
                        v-model="forgot.email"
                        label="Email"
                        name="email"
                        outlined
                        prepend-icon="mdi-email"
                        type="email"
                      />
                      <div class="text-center mt-4">
                        <v-btn color="primary" large type="submit">RESET PASSWORD</v-btn>
                        <v-btn color="secondary" large outlined class="mx-2" @click="step = 0">SIGN IN</v-btn>
                      </div>
                    </v-form>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { gql } from 'apollo-boost';
import { User } from '@/models/User';
export default {
  name: 'LoginRegister',
  data: () => ({
    ping: '',

    step: 0,

    register: new User(),

    firstNameRules: [v => !!v || 'First name is required'],

    lastNameRules: [v => !!v || 'Last name is required'],

    emailRules: [v => !!v || 'E-mail is required', v => /.+@.+\..+/.test(v) || 'E-mail must be valid'],

    telNumberRules: [v => !!v || 'Mobile Number is required'],

    passwordRules: [v => !!v || 'Password is required', v => (v && v.length >= 6) || 'minimum 6 characters'],

    addy1Rules: [v => !!v || 'Address 1 is required'],

    cityRules: [v => !!v || 'City is required'],

    postcodeRules: [v => !!v || 'postcode is required'],

    signin: {
      email: '',
      password: '',
    },

    forgot: {
      email: '',
    },

    successMsg: '',
    errorMsg: '',

    valid: true,
  }),
  apollo: {
    ping: {
      query: gql`
        query {
          ping
        }
      `,
      fetchPolicy: 'network-only',
      result(data, key) {
        console.log(data, key);
      },
    },
  },
  methods: {
    async loginUser() {
      const self = this;
      if (!self.$refs.signinFrm.validate()) {
        self.$swal('Error', 'Validation failed', 'error');
        return;
      }
      try {
        const userData = await this.$apollo.mutate({
          mutation: gql`
            mutation($email: String!, $password: String!) {
              login(email: $email, password: $password) {
                user {
                  id
                  email
                  role
                }
                token
              }
            }
          `,
          variables: {
            email: this.signin.email,
            password: this.signin.password,
          },
        });

        if (userData) {
          this.$token = userData?.data?.login?.token;
          this.$role = userData?.data?.login?.user?.role;
          localStorage.setItem('token', this.$token);
          localStorage.setItem('role', userData?.data?.login?.user?.role);
          localStorage.setItem('userId', userData?.data?.login?.user?.id);
          console.log('Logging in as:' + this.$role);
          if (this.$role == 'admin') this.$router.push('/admin/dashboard');
          else if (this.$role == 'user') self.$swal('Error', 'Unable to Login as a regular User', 'error');
          else self.$swal('Error', 'Unable to Login', 'error');
        }
      } catch (e) {
        console.log(`Login Failed ${JSON.stringify(e)}`);
        self.$swal('Error', e.graphQLErrors[0].message, 'error');
        self.errorMsg = `${e.message}`;
      }
    },

    async registerUser() {
      const self = this;
      if (!self.$refs.registerFrm.validate()) {
        self.$swal('Error', 'Validation failed', 'error');
        return;
      }
      try {
        const userData = await this.$apollo.mutate({
          mutation: gql`
            mutation createUser($user: UserCreateInput!) {
              createUser(user: $user) {
                id
                email
                role
              }
            }
          `,
          variables: {
            user: {
              firstName: this.register.firstName,
              lastName: this.register.lastName,
              email: this.register.email,
              telNumber: this.register.telNumber,
              password: this.register.password,
              fullAddress: this.register.fullAddress,
              role: this.register.role,
            },
          },
        });

        if (userData) {
          self.$token = userData.data.createUser.token;
          this.step--;
          this.$swal('Success', 'You have successfully registered, please login', 'success');
        }
      } catch (e) {
        // TODO SWAL error
        console.log(`Registration Failed ${JSON.stringify(e)}`);
        self.errorMsg = `${e.message}`;
      }
    },
    async forgotPassword() {
      const self = this;
      try {
        await this.$apollo
          .mutate({
            mutation: gql`
              mutation getResetPasswordLink($email: String!) {
                getResetPasswordLink(email: $email)
              }
            `,
            variables: {
              email: self.forgot.email,
            },
          })
          .then(() => {
            self.$swal('Success', 'Please check your email for reset password link.', 'success');
          });
      } catch (e) {
        console.log(`Forgot Password fetch link failed: ${JSON.stringify(e)}`);
        self.errorMsg = `${e.message}`;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
